// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"458":"9e525c509d27a3f6","562":"74e571ccf6208ee5","866":"7f1ae0b540439b52"}[chunkId] + ".js";
};